export const ANONYMOUS_FLOW_ANALYTICS_SOURCE = "anonymous-save-test";
